import { each, valuesIn } from 'lodash-es';

import { FormField, Select, SelectProps } from '~/core/shared/components';
import { Option, OptionGroup } from '~/core/shared/types';
import { FieldProps } from '../DocumentField.component';

const getSelectFieldComponentOptions = (
  field: Resources.FormSelectField,
): Partial<SelectProps> => {
  const groups: Record<string, OptionGroup<string | readonly string[]>> = {};
  const options: Array<Option<string | readonly string[]>> = [];
  each(field.options, (option) => {
    const o = {
      label: option.label,
      value: option.value,
    };
    if (option.group) {
      const group = groups[option.group] || {
        label: option.group,
        options: [],
      };

      group.options.push(o);
      groups[group.label] = group;
    } else {
      options.push(o);
    }
  });

  return {
    groups: valuesIn(groups),
    options,
    ...(field.nullable && { placeholder: 'Choose...' }),
  };
};

export const SelectField = ({
  field,
  ...props
}: FieldProps<Resources.FormSelectField>) => (
  <FormField
    component={Select}
    {...getSelectFieldComponentOptions(field)}
    {...props}
  />
);
